export default function SmartPhone() {
  return (
    <svg
      width="74"
      height="126"
      viewBox="0 0 82 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="4" width="74" height="126" rx="14" stroke="#03096F" strokeWidth="8" />
      <circle cx="41" cy="110" r="8" fill="#03096F" />
    </svg>
  );
}
